/* unplugin-vue-components disabled */import { render } from "./ExamQuizResults.vue?vue&type=template&id=7adfbb9d&scoped=true&ts=true"
import script from "./ExamQuizResults.vue?vue&type=script&lang=ts"
export * from "./ExamQuizResults.vue?vue&type=script&lang=ts"

import "./ExamQuizResults.vue?vue&type=style&index=0&id=7adfbb9d&scoped=true&lang=scss"
import "./ExamQuizResults.vue?vue&type=style&index=1&id=7adfbb9d&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7adfbb9d"]])

export default __exports__